<template>
  <span class="echarts-pie"><div id="main-pie"></div></span>
</template>

<script>
import * as echarts from 'echarts';
import GetFormatTime from '../../../utils/time-format.js';
export default {
  props: {
    data: {
      type: [Object, Array]
    },
    menuType: {
      type: String
    }
  },
  data() {
    return {
      barWidth: 10,
      newchartName: ['2020-08-25', '2020-08-26', '2020-08-27', '2020-08-28', '2020-08-29', '2020-08-30', '2020-08-31'],
      newchartValue1: ['962.2', '1942.8', '1786.6', '1792.8', '1772.0', '1798.8', '1772.5'],
      newchartValue2: ['961.4', '1853.9', '1665.0', '1671.0', '1660.2', '1667.0', '1653.3'],

      path: 'path://M1390,595h79l-39,22Z',
      color1: {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            //第一节下面
            offset: 0,
            color: '#1C98CD'
          },
          {
            offset: 1,

            color: 'rgba(61,187,255,.16)'
          }
        ]
      },
      color2: {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            //第一节下面
            offset: 0,
            color: '#E7AB47'
          },
          {
            offset: 1,
            color: 'rgba(255,164,41,.16)'
          }
        ]
      },
      yAxisName: this.menuType
    };
  },
  methods: {
    reset() {
      this.$nextTick(function() {
        var myChart = echarts.init(document.getElementById('main-pie'));
        let tmp = this.init();
        if (tmp) {
          myChart.setOption(tmp);
        }else{
          console.log('数据问题chargingStatistics');
        }
      });
    },
    init() {
      let newchartValueEnd1 = [];
      let newchartValueEnd2 = [];
      let newchartValueDo1 = [];
      let newchartValueDo2 = [];
      let title1 = [];
      let title2 = [];
      let xAxis = [];
      if (!this.data.chargingStatistics) {
        let timeList = [];
        let time = new Date().getTime();
        for (let i = 1;i < 8;i++) {
          timeList.push(time - i * 24 * 3600 * 1000);
        }
        timeList.sort(function (a, b) {
          return a - b;
        });
        for (let j = 0;j < timeList.length;j++) {
          xAxis.push(GetFormatTime({
            time: timeList[j],
            format: "yyyy-MM-dd"
          }))
        }
        this.newchartValue1 = [0, 0, 0, 0, 0, 0, 0];
        this.newchartValue2 = [0, 0, 0, 0, 0, 0, 0];
      } else {
        xAxis = this.data.chargingStatistics.timestamps;
        this.newchartValue1 = this.data.chargingStatistics.data;
        this.newchartValue2 = this.data.dischargingStatistics.data;
        this.newchartValue1.forEach((item, index) => {
          newchartValueEnd1.push({ name: '', value: item, symbolPosition: 'end' });
          newchartValueDo1.push({ name: '', value: item });
        });
        this.newchartValue2.forEach(item => {
          newchartValueEnd2.push({ name: '', value: item, symbolPosition: 'end' });
          newchartValueDo2.push({ name: '', value: item });
        });
        //获取数据最大值
        let list = this.newchartValue1.concat(this.newchartValue2).sort(function(a, b) {
          return b - a;
        });
        var max = list[0];
        if (parseInt(max) < 100) {
          max = 100;
        } else {
          max = max + 20;
        }
      }
      this.newchartValue1.forEach((item, index) => {
        let str = {
          text: item,
          textAlign: 'center',
          textStyle: {
            color: 'rgba(61,187,255,1)',
            fontSize: 12
          },
          top: '8%'
        };
        switch (index) {
          case 0: {
            str.left = '18%';
            break;
          }
          case 1: {
            str.left = '31%';
            break;
          }
          case 2: {
            str.left = '43%';
            break;
          }
          case 3: {
            str.left = '55%';
            break;
          }
          case 4: {
            str.left = '67%';
            break;
          }
          case 5: {
            str.left = '79%';
            break;
          }
          case 6: {
            str.left = '91%';
            break;
          }
        }
        title1.push(str);
      });
      this.newchartValue2.forEach((item, index) => {
        let str = {
          text: item,
          textAlign: 'center',
          textStyle: {
            color: 'rgba(255,146,41,1)',
            fontSize: 12
          },
          top: '15%'
        };
        switch (index) {
          case 0: {
            str.left = '18%';
            break;
          }
          case 1: {
            str.left = '31%';
            break;
          }
          case 2: {
            str.left = '43%';
            break;
          }
          case 3: {
            str.left = '55%';
            break;
          }
          case 4: {
            str.left = '67%';
            break;
          }
          case 5: {
            str.left = '79%';
            break;
          }
          case 6: {
            str.left = '91%';
            break;
          }
        }
        title2.push(str);
      });
      let title = title1.concat(title2);
      let op = {
        legend: {
          top: 0,
          right: 0,
          icon: 'rect',
          itemWidth: 17, // 图例标记的图形宽度。[ default: 25 ]
          itemHeight: 12, // 图例标记的图形高度。[ default: 14 ]
          itemGap: 9, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
          textStyle: {
            fontSize: 12,
            color: '#fff'
          },
          data: ['充电量', '放电量']
        },
        //提示框
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function(param) {
            var resultTooltip =
              "<div style='background:rgba(13,5,30,.3);border:1px solid rgba(255,255,255,.2);padding:5px 10px;border-radius:4px;'>" +
              "<div style='text-align:center;'>" +
              param[0].name +
              '</div>' +
              "<div style='padding-top:5px;'>" +
              "<span style='display:inline-block;border-radius:4px;width:20px;height:10px;background-color:rgba(61,187,255,.3);border: 2px solid #3eb6f5;'></span>" +
              "<span style=''> " +
              param[0].seriesName +
              ': </span>' +
              "<span style=''>" +
              param[0].value +
              '</span>' +
              '</div>' +
              "<div style='padding-top:5px;'>" +
              "<span style='display:inline-block;border-radius:4px;width:20px;height:10px;background-color:rgba(255,164,41,.3);border: 2px solid #ffc241;'></span>" +
              "<span style=''> " +
              param[1].seriesName +
              ': </span>' +
              "<span style=''>" +
              param[1].value +
              '</span>' +
              '</div>';
            return resultTooltip;
          }
        },
        title: '',
        grid: {
          top: '25%',
          left: '7%',
          bottom: '0%',
          right: '5%',
          containLabel: true
        },
        animation: false,
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#0AB8F4'
              }
            },
            axisLabel: {
              inside: false,
              textStyle: {
                color: '#0AB8F4',
                fontWeight: 'normal',
                fontSize: 10
              },
              formatter: function(params) {
                let res = '';
                let strs = [];
                let y = '',
                  m = '',
                  d = '';
                strs = params.split('-');
                y = strs[0];
                m = strs[1];
                d = strs[2];
                return m + '-' + d + '\n' + y;
              },
              margin: 20 //刻度标签与轴线之间的距离。
            },
            data: xAxis
          },
          {
            type: 'category',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            data: xAxis
          }
        ],
        yAxis: [
          {
            name: this.yAxisName=='home'?'电量(MWh)':'电量(kWh)',
            nameTextStyle: {
              color: '#0AB8F4',
              fontSize: 12,
              padding: [0, 0, 0, -30]
            },
            show: true,
            type: 'value',
            axisLabel: {
              textStyle: {
                fontSize: 10,
                color: '#0AB8F4'
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(4, 126, 232, 0.1)',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '充电量',
            type: 'pictorialBar',
            symbolSize: [this.barWidth, 10],
            symbolOffset: ['-81%', -5],
            symbolPosition: 'end',
            z: 15,
            color: 'rgba(29,139,193,0.9)',
            zlevel: 4,
            data: this.newchartValue1
          },
          {
            name: '放电量',
            type: 'pictorialBar',
            symbolSize: [this.barWidth, 10],
            symbolOffset: ['81%', -5],
            symbolPosition: 'end',
            z: 15,
            color: 'rgba(205,151,67,0.9)',
            zlevel: 2,
            data: this.newchartValue2
          },
          {
            name: '充电量',
            type: 'bar',
            barGap: '60%',
            barWidth: this.barWidth,
            itemStyle: {
              color: this.color1,
              borderColor: this.color1,
              borderWidth: 1,
              borderType: 'solid'
            },
            label: {
              show: false,
              formatter: '{c}' + '%',
              position: 'left',
              color: 'rgba(119,167,255,1)',
              fontSize: 12,
              textAlign: 'center'
            },
            zlevel: 2,
            data: this.newchartValue1
          },
          {
            name: '放电量',
            type: 'bar',
            barGap: '60%',
            barWidth: this.barWidth,
            show: false,
            itemStyle: {
              // color: 'rgba(255,164,41,.16)',
              color: this.color2,
              borderColor: this.color2,
              borderWidth: 1,
              borderType: 'solid'
            },
            label: {
              show: false,
              formatter: '{c}' + '%',
              position: 'right',
              color: 'rgba(255,228,59,1)',
              fontSize: 12,
              textAlign: 'center'
            },
            zlevel: 2,
            data: this.newchartValue2
          },
          {
            name: '已开工已完成',
            type: 'pictorialBar',
            symbolSize: [this.barWidth, 10],
            symbolOffset: ['-81%', 5],
            z: 12,
            color: '#3eb6f5',
            data: newchartValueDo1
          },
          {
            name: '已完成已合格',
            type: 'pictorialBar',
            symbolSize: [this.barWidth, 10],
            symbolOffset: ['81%', 5],
            z: 12,
            color: '#ffc241',

            data: newchartValueDo2
          },
          //背景
          {
            name: '工程量',
            type: 'bar',
            xAxisIndex: 1,
            barGap: '60%',
            data: [max, max, max, max, max, max, max],
            zlevel: 1,
            barWidth: this.barWidth,
            itemStyle: {
              normal: {
                color: 'rgba(61,187,255,.16)'
              }
            }
          },
          {
            name: '合格量',
            type: 'bar',
            xAxisIndex: 1,
            barGap: '60%',
            data: [max, max, max, max, max, max, max],
            zlevel: 1,
            barWidth: this.barWidth,
            itemStyle: {
              normal: {
                color: 'rgba(255,164,41,.16)'
              }
            }
          },
          {
            name: '已开工已完成',
            type: 'pictorialBar',
            symbolSize: [this.barWidth, 10],
            symbolOffset: ['-81%', 5],
            z: 12,
            color: '#3eb6f5',

            data: [
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              }
            ]
          },
          {
            name: '已完成已合格',
            type: 'pictorialBar',
            symbolSize: [this.barWidth, 10],
            symbolOffset: ['81%', 5],
            z: 12,
            color: '#ffc241',

            data: [
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              },
              {
                name: '',
                value: max
              }
            ]
          },
          // 头

          {
            name: '已开工未完成',
            type: 'effectScatter',
            rippleEffect: {
              period: 1,
              scale: 4,
              brushType: 'fill'
            },
            show: true,
            z: 20,
            zlevel: 2,
            symbolPosition: 'end',
            // symbol: path,
            symbolSize: [6, 4],
            symbolOffset: [-8, 2],
            itemStyle: {
              normal: {
                // shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 5,
                shadowOffsetY: 3,
                shadowOffsetX: 0,
                color: 'rgba(119,167,255,1)'
              }
            },
            data: [
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              }
            ]
          },
          {
            name: '已开工未完成',
            type: 'effectScatter',
            rippleEffect: {
              period: 1,
              scale: 4,
              brushType: 'fill'
            },
            show: false,
            z: 20,
            zlevel: 2,
            symbolPosition: 'end',
            // symbol: path,
            symbolSize: [6, 4],
            symbolOffset: [8, 1],
            itemStyle: {
              normal: {
                // shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 5,
                shadowOffsetY: 3,
                shadowOffsetX: 0,
                color: 'rgba(255,164,41,0.5)'
              }
            },
            data: [
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              },
              {
                name: '',
                value: max,
                symbolPosition: 'end'
              }
            ]
          }
        ]
      };
      return op;
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.echarts-pie {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: inline-block;
  #main-pie {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/echarts-pie.vue